/* global window */
import { createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';
import rootReducer from './reducer/rootReducer';

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = () => {
    const store = createStore(rootReducer, composeEnhancer(applyMiddleware(reduxThunk)));

    if (process.env.NODE_ENV !== 'production') {
        if (module.hot) {
            console.log('Module Hot');
            module.hot.accept('./reducer/rootReducer', () => {
                store.replaceReducer(rootReducer);
            });
        }
    }

    return store;
};

export default configureStore;
